// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Segoe UI', system-ui, sans-serif;
  line-height: 1.5;
  color: #0f172a;
  background: linear-gradient(160deg, #e0e7ff 0%, #f8fafc 40%, #ecfdf5 100%);
  min-height: 100vh;
}

.shell {
  max-width: 52rem;
  margin: 2.5rem auto 3rem;
  padding: 0 1.25rem;
}

.shell-header {
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem 1.5rem 0;
  box-shadow: 0 12px 40px rgb(15 23 42 / 0.1);
  border: 1px solid rgb(226 232 240 / 0.9);
}

.brand {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.brand-mark {
  width: 3rem;
  height: 3rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #6366f1, #22c55e);
  box-shadow: 0 8px 20px rgb(99 102 241 / 0.35);
}

.brand h1 {
  margin: 0;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
}

.tagline {
  margin: 0.15rem 0 0;
  font-size: 0.95rem;
  color: #64748b;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  border-top: 1px solid #e2e8f0;
  padding: 0.5rem 0 0;
}

.tab {
  border: none;
  background: transparent;
  padding: 0.65rem 1rem;
  border-radius: 10px 10px 0 0;
  font: inherit;
  color: #64748b;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.tab:hover {
  color: #334155;
  background: #f1f5f9;
}

.tab.active {
  color: #1e293b;
  background: #f8fafc;
  font-weight: 600;
  box-shadow: 0 -1px 0 #fff;
}

.shell-body {
  margin-top: -1px;
  background: #f8fafc;
  border-radius: 0 0 16px 16px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
  border-top: none;
  min-height: 14rem;
}

/* Overview */
.overview {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));
  gap: 0.75rem;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.stat-value {
  font-size: 1.75rem;
  line-height: 1.1;
}

.stat-value.accent {
  color: #4f46e5;
}

.stat-value.muted {
  color: #16a34a;
}

.progress-block {
  background: #fff;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  border: 1px solid #e2e8f0;
}

.progress-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #475569;
}

.progress-pct {
  font-weight: 600;
  color: #0f172a;
}

.progress-track {
  height: 10px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #6366f1, #22c55e);
  transition: width 0.35s ease;
}

.recent h3 {
  margin: 0 0 0.75rem;
  font-size: 1rem;
}

.recent-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.recent-list li {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  padding: 0.6rem 0.75rem;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 0.9rem;
}

.recent-list .done {
  text-decoration: line-through;
  color: #94a3b8;
}

.recent-list time {
  flex-shrink: 0;
  font-size: 0.75rem;
  color: #94a3b8;
}

/* Tasks */
.task-board {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.task-form {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.task-form input {
  flex: 1 1 12rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  font: inherit;
}

.task-form input:focus {
  outline: 2px solid #a5b4fc;
  border-color: #818cf8;
}

.task-form button {
  padding: 0.65rem 1.1rem;
  border-radius: 10px;
  border: none;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  background: #4f46e5;
  color: #fff;
}

.task-form button:hover {
  background: #4338ca;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.filter {
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #fff;
  font: inherit;
  font-size: 0.85rem;
  cursor: pointer;
  color: #475569;
}

.filter:hover {
  border-color: #94a3b8;
}

.filter.active {
  background: #eef2ff;
  border-color: #818cf8;
  color: #3730a3;
  font-weight: 600;
}

.filter.ghost {
  margin-left: auto;
  border-style: dashed;
}

.task-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.task {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.task.done .task-title {
  text-decoration: line-through;
  color: #94a3b8;
}

.task-main {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  cursor: pointer;
  flex: 1;
}

.task-main input {
  margin-top: 0.2rem;
  width: 1.05rem;
  height: 1.05rem;
  accent-color: #4f46e5;
}

.task-title {
  flex: 1;
}

.task-remove {
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.25rem;
  border-radius: 6px;
}

.task-remove:hover {
  color: #dc2626;
  background: #fef2f2;
}

.task-empty {
  padding: 1.5rem;
  text-align: center;
  color: #94a3b8;
  font-size: 0.95rem;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
}

/* About */
.about p {
  margin: 0 0 1rem;
  color: #475569;
}

.about code {
  font-size: 0.88em;
  background: #e2e8f0;
  padding: 0.1rem 0.35rem;
  border-radius: 6px;
}

.about-list {
  margin: 0;
  padding-left: 1.2rem;
  color: #334155;
}

.about-list li {
  margin-bottom: 0.35rem;
}

@media (max-width: 520px) {
  .brand {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter.ghost {
    margin-left: 0;
  }

  .recent-list li {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,cAAc;EACd,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', system-ui, sans-serif;\n  line-height: 1.5;\n  color: #0f172a;\n  background: linear-gradient(160deg, #e0e7ff 0%, #f8fafc 40%, #ecfdf5 100%);\n  min-height: 100vh;\n}\n\n.shell {\n  max-width: 52rem;\n  margin: 2.5rem auto 3rem;\n  padding: 0 1.25rem;\n}\n\n.shell-header {\n  background: #fff;\n  border-radius: 16px;\n  padding: 1.5rem 1.5rem 0;\n  box-shadow: 0 12px 40px rgb(15 23 42 / 0.1);\n  border: 1px solid rgb(226 232 240 / 0.9);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.brand-mark {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #6366f1, #22c55e);\n  box-shadow: 0 8px 20px rgb(99 102 241 / 0.35);\n}\n\n.brand h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.tagline {\n  margin: 0.15rem 0 0;\n  font-size: 0.95rem;\n  color: #64748b;\n}\n\n.tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  border-top: 1px solid #e2e8f0;\n  padding: 0.5rem 0 0;\n}\n\n.tab {\n  border: none;\n  background: transparent;\n  padding: 0.65rem 1rem;\n  border-radius: 10px 10px 0 0;\n  font: inherit;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.tab:hover {\n  color: #334155;\n  background: #f1f5f9;\n}\n\n.tab.active {\n  color: #1e293b;\n  background: #f8fafc;\n  font-weight: 600;\n  box-shadow: 0 -1px 0 #fff;\n}\n\n.shell-body {\n  margin-top: -1px;\n  background: #f8fafc;\n  border-radius: 0 0 16px 16px;\n  padding: 1.5rem;\n  border: 1px solid #e2e8f0;\n  border-top: none;\n  min-height: 14rem;\n}\n\n/* Overview */\n.overview {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));\n  gap: 0.75rem;\n}\n\n.stat-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n}\n\n.stat-value {\n  font-size: 1.75rem;\n  line-height: 1.1;\n}\n\n.stat-value.accent {\n  color: #4f46e5;\n}\n\n.stat-value.muted {\n  color: #16a34a;\n}\n\n.progress-block {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  border: 1px solid #e2e8f0;\n}\n\n.progress-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  color: #475569;\n}\n\n.progress-pct {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.progress-track {\n  height: 10px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #6366f1, #22c55e);\n  transition: width 0.35s ease;\n}\n\n.recent h3 {\n  margin: 0 0 0.75rem;\n  font-size: 1rem;\n}\n\n.recent-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.recent-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 1rem;\n  padding: 0.6rem 0.75rem;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  font-size: 0.9rem;\n}\n\n.recent-list .done {\n  text-decoration: line-through;\n  color: #94a3b8;\n}\n\n.recent-list time {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n/* Tasks */\n.task-board {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.task-form {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.task-form input {\n  flex: 1 1 12rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid #cbd5e1;\n  font: inherit;\n}\n\n.task-form input:focus {\n  outline: 2px solid #a5b4fc;\n  border-color: #818cf8;\n}\n\n.task-form button {\n  padding: 0.65rem 1.1rem;\n  border-radius: 10px;\n  border: none;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  background: #4f46e5;\n  color: #fff;\n}\n\n.task-form button:hover {\n  background: #4338ca;\n}\n\n.filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.filter {\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  font: inherit;\n  font-size: 0.85rem;\n  cursor: pointer;\n  color: #475569;\n}\n\n.filter:hover {\n  border-color: #94a3b8;\n}\n\n.filter.active {\n  background: #eef2ff;\n  border-color: #818cf8;\n  color: #3730a3;\n  font-weight: 600;\n}\n\n.filter.ghost {\n  margin-left: auto;\n  border-style: dashed;\n}\n\n.task-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.task {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.65rem 0.85rem;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n}\n\n.task.done .task-title {\n  text-decoration: line-through;\n  color: #94a3b8;\n}\n\n.task-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  cursor: pointer;\n  flex: 1;\n}\n\n.task-main input {\n  margin-top: 0.2rem;\n  width: 1.05rem;\n  height: 1.05rem;\n  accent-color: #4f46e5;\n}\n\n.task-title {\n  flex: 1;\n}\n\n.task-remove {\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 0.25rem;\n  border-radius: 6px;\n}\n\n.task-remove:hover {\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n.task-empty {\n  padding: 1.5rem;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 0.95rem;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n}\n\n/* About */\n.about p {\n  margin: 0 0 1rem;\n  color: #475569;\n}\n\n.about code {\n  font-size: 0.88em;\n  background: #e2e8f0;\n  padding: 0.1rem 0.35rem;\n  border-radius: 6px;\n}\n\n.about-list {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: #334155;\n}\n\n.about-list li {\n  margin-bottom: 0.35rem;\n}\n\n@media (max-width: 520px) {\n  .brand {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .filter.ghost {\n    margin-left: 0;\n  }\n\n  .recent-list li {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
